import get from 'lodash/get';
function FormInput({
                       label,
                       name,
                       errors,
                       type = "text",
                       required = false,
                       value,
                       defaultValue = "",
                       placeholder = "",
                       textarea = false,
                       maxLengthText = "max length 1000 character",
                       disabled = false,
                       showHeaderLabel = true,
                       validation = {},
                   }) {
    const InputTag = textarea ? "textarea" : "input";
    const errorMessage = get(errors, `${name}.message`);
    return (
        <div className="mb-3">
            {
                showHeaderLabel && <span className="form-label">{label.replace("Assign", "")}</span>
            }
            <div className="form-floating">
                <InputTag
                    disabled={disabled}
                    type={type}
                    className={`form-control text-primary ps-2 shadow-none ${textarea ? "textarea-h-130" : ""}`}
                    {...validation}
                    {...(value !== undefined ? { value } : { defaultValue })}
                    placeholder={placeholder || label}
                />
                <label htmlFor={name} className="ps-2 text-body-tertiary form-icon-label text-primary">
                    {label}{required && "(*)"}
                </label>
                <div className="d-flex justify-content-between">
          <span>
            {errorMessage && (
                <span className="fs-9 fw-bold text-danger">{errorMessage}</span>
            )}
          </span>
                    <span className="fs-10 fw-bold">{maxLengthText}</span>
                </div>
            </div>
        </div>
    );
}

export default FormInput;
